<template>
	<div class="wai">
		<div style="
	  		color: #3e3e3e;
	  		font-size: 18px;margin-bottom: 15px;">用户管理>用户运营>用户运营-设置人群</div>
		<div class="title">
			<div class="blue"></div>
			<div style="flex: 1;">运营计划管理</div>
		</div>
		<!-- 第一部分 -->
		<div class="demo1">
			<div class="demo1_list1">
				<div>人群名称</div>
				<div>
					<el-input size="small" v-model="filter.name" style="width: 300px;" type="text"
						placeholder="人群名称,不超过20个字(不能含标点符号)"></el-input>
				</div>
			</div>
			<div class="demo1_list1">
				<div>人群描述</div>
				<div>
					<el-input size="small" v-model="filter.labelDesc" style="width: 300px;" type="text"
						placeholder="人群名称,不超过20个字(不能含标点符号)"></el-input>
				</div>
			</div>
			<div class="demo1_list1">
				<div>更新方式</div>
				<div class="demo1_radaios">
					<el-radio v-model="filter.updateWay" label="0">手动更新</el-radio>
					<el-radio v-model="filter.updateWay" label="1">例行更新（每天12时,根据筛选条件更新一遍人群）</el-radio>
				</div>
			</div>
			<div class="demo1_list2">
				<div class="titles">标签选择</div>
				<div class="persons">
					<div v-for="(item,index) in labellist" :key="index">
						<el-radio v-model="filter.labelId" :label="item.value">{{item.label}}</el-radio>
					</div>
				</div>
			</div>
		</div>
		<!-- 第一部分结束 -->
		<!-- 第二部分开始 -->
		<el-dialog title="添加标签" :visible.sync="dialogVisible" width="30%">
			<el-form label-width="90px">
				<el-form-item label="标签名称" required>
					<el-input style="width:280px;" v-model="labelname" size="medium" />
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 第二部分结束 -->
		<!-- 第三部分开始 -->
		<!-- <div class="screen">
			<div class="screenlist">
				 <p>自定义条件</p>
				 <el-button size="small" style="margin-top: 10px;margin-bottom: 10px;">用户标签</el-button>
				  <p>自定义条件</p>
			</div>
			<div class="screenlist">
				 <p>创建的人群同时满足以下条件</p>
			</div>
		</div> -->
		<!-- 第三部分结束 -->
		<div class="mybotton">
			<el-button size="small" @click="goback">取消</el-button>
			<el-button type="primary" size="small" @click="add">保存</el-button>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				filter: {
					labelDesc: "",
					labelId: "",
					name: "",
					updateWay: ""
				},
				labellist: [
					// {}
				],
				updatemethod: "", //更新方式
				radio: "",
				dialogVisible: false,
				labelname: "",
				//第三部分表格
				tableData: [{
					totalmoney: 2000,
					totalnum: 10,
					agreemoney: 38,
					jifen: 38,
					duihuannum: 18,
					youhui: 38,
					cishu: 38
				}]
			}
		},
		mounted() {
			this.getcard()
		},
		methods: {
			//获取标签
			getcard() {
				this.$http.get("dUserLabel/list", {
					params: {
						page: 1,
						size: 999999
					}
				}, {
					emulateJSON: true
				}).then(function(res) {
					this.labellist = []
					console.log(res)
					if (res.body.code == 200) {
						for (let i in res.body.data) {
							var a = {
								label: res.body.data[i].labelName,
								value: res.body.data[i].id
							}
							this.labellist.push(a)
						}
					}
					console.log(this.labellist)
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			// 添加人群
			add() {
				console.log(this.filter)
				this.$http.post("dUserCrowd/insert", JSON.stringify(this.filter)).then(function(res) {
					console.log(res)
					if (res.body.code == 200) {
						this.$message.success("添加成功")
						this.filter = {
							labelDesc: "",
							labelId: "",
							name: "",
							updateWay: ""
						}
						this.$router.go(-1)
					} else {
						this.$message.error(res.body.msg)
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			goback() {
				this.$router.go(-1)
			},
			claer() {
				this.$confirm('是否要删除该标签?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}
		}
	};
</script>
<style lang="less" scoped>
	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.title2 {
		margin-top: 30px;
		margin-bottom: 30px;
	}

	// 第一部分
	.demo1 {
		width: 100%;

		.demo1_list1 {
			margin-top: 20px;
			display: flex;

			div {
				&:nth-child(1) {
					width: 200px;
				}
			}

			.demo1_radaios {
				display: flex;
			}
		}
	}

	.persons {
		width: 60%;
		display: flex;
		flex-wrap: wrap;

		div {
			margin-left: 15px;
		}
	}

	// 第二部分
	.demo2 {
		box-sizing: border-box;
		width: 100%;
		padding: 20px;
		padding-top: 10px;
		display: flex;
		flex-wrap: wrap;
		border: 1px solid #D3D3D3;

		.demo2_label {
			cursor: pointer;
			height: 23px;
			margin-top: 10px;
			padding: 10px;
			background: #FFFFFF;
			border: 1px solid #D3D3D3;
			position: relative;

			& {
				margin-right: 20px;
			}

			&:hover div {
				display: block;
			}

			div {
				display: none;
				text-align: center;
				line-height: 12px;
				font-size: 12px;
				color: #FFFFFF;
				border-radius: 50%;
				position: absolute;
				right: -5px;
				top: -5px;
				height: 15px;
				width: 15px;
				background-color: #000000;
			}
		}

		.demo2_add {
			height: 23px;
			margin-top: 10px;
			cursor: pointer;
			padding: 10px;
			background: #FFFFFF;
			border: 1px dashed #D3D3D3;
		}
	}

	.demo1_list2 {
		margin-top: 20px;
		display: flex;

		.titles {
			color: #3E3E3E;
			margin-right: 120px;
		}
	}

	// botton
	.mybotton {
		margin-top: 50px;
		margin-bottom: 100px;
		margin-left: 10%;
	}
</style>